import z from 'zod'
import { EvidenceStatus, EvidenceType } from '../enums'
import {
  INVESTIGATION_EVIDENCE_DESCRIPTION_MAX_LENGTH,
  INVESTIGATION_EVIDENCE_NAME_MAX_LENGTH,
  LONG_STRING_MAX_LENGTH,
  SHORT_STRING_MAX_LENGTH,
  STRING_MIN_LENGTH,
} from '../validationConfig'
import { nullableString } from './utils'

export const renameInvestigationInputSchema = z.object({
  name: z.string().trim().min(STRING_MIN_LENGTH).max(SHORT_STRING_MAX_LENGTH),
})

export const investigationInvolvedPersonInputSchema = z.object({
  employeeId: z.uuidv7(),
  role: z.string().trim().min(STRING_MIN_LENGTH).max(SHORT_STRING_MAX_LENGTH),
  note: nullableString(z.string().trim().max(LONG_STRING_MAX_LENGTH)),
})

export const investigationEvidenceInputSchema = z.object({
  name: z.string().min(STRING_MIN_LENGTH).max(INVESTIGATION_EVIDENCE_NAME_MAX_LENGTH),
  type: z.enum(EvidenceType),
  status: z.enum(EvidenceStatus).nullable(),
  description: nullableString(z.string().max(INVESTIGATION_EVIDENCE_DESCRIPTION_MAX_LENGTH)),
  employeeId: z.uuid().nullable(),
})
